import React from 'react';
import { AlertCircle } from 'lucide-react';

const NoDataError = ({ message = 'No data available to display.' }) => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
    <AlertCircle className="text-gray-300 mb-6" size={72} />
    <h2 className="text-2xl font-semibold text-gray-700 mb-3">Nothing to Show</h2>
    <p className="text-gray-500 max-w-md">{message}</p>
  </div>
);

export default NoDataError;
